<template>
  <div class="mb-4 h-100 d-flex justify-content-center align-items-center avatar-group position-relative">
    <div class="position-relative">
      <b-img
        :src="getFotoSrc"
        alt="Foto cliente rural"
        class="rounded-circle header-profile avatar-xl"
      />

      <div
        v-if="loading"
        class="spinner-overlay d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle"
      >
        <b-spinner variant="primary" />
      </div>

      <div class="avatar-sm edit-img position-absolute bottom-0 end-0">
        <label for="file-upload" class="avatar-title rounded-circle bg-primary mb-0" style="cursor: pointer">
          <i class="mdi mdi-pencil font-size-16 align-middle me-1"></i>
        </label>
        <input
          type="file"
          ref="fileInput"
          id="file-upload"
          @change="carregarFotoLocal"
          accept=".png, .jpg, .jpeg, .webp, .PNG, .JPG, .JPEG"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FotoClienteRural",

  props: {
    fotoPerfil: {
      type: [Object, String],
      required: true,
      default: () => ({ base64: null, file: null })
    },

    loading: {
      type: Boolean,
      default: false
    },

    modoEdicaoFoto: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      fotoLocal: null,
      sqClienteLocal: null,
      cdCooperadoLocal: null
    };
  },

  created() {
    if (this.modoEdicaoFoto) {
      this.buscaDadosSotre();
    }
  },

  computed: {
    getFotoSrc() {
      if (this.fotoLocal) {
        return this.fotoLocal;
      }

      const foto = this.fotoPerfil;

      if (typeof foto === 'string') {
        if (foto.startsWith("data:image")) {
          console.log('Usando base64 completo da prop');
          return foto;
        }
        else if (foto.length > 100 && !foto.includes('.')) {
          console.log('Usando base64 puro da prop');
          return `data:image/jpeg;base64,${foto}`;
        }
        else if (foto.includes('.webp') || foto.includes('.jpg') ||
                foto.includes('.jpeg') || foto.includes('.png')) {
          return require('@/assets/images/sem-foto.png');
        }
      }

      if (foto?.base64) {
        if (foto.base64.startsWith("data:image")) {
          console.log('Usando base64 completo do objeto');
          return foto.base64;
        }
        else if (foto.base64.length > 100 && !foto.base64.includes('.')) {
          return `data:image/jpeg;base64,${foto.base64}`;
        }
      }
      return require('@/assets/images/sem-foto.png');
    }
  },

  watch: {
    fotoPerfil: {
      deep: true,
      immediate: true
    },

    modoEdicaoFoto(newValue) {
      if (newValue) {
        this.buscaDadosSotre();
      }
    }
  },

  methods: {
    carregarFotoLocal(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files || !files.length) {
        console.log('Nenhum arquivo selecionado');
        return;
      }

      const file = files[0];
      console.log('Arquivo selecionado:', file.name);

      const extensao = file.name.split('.').pop().toLowerCase();
      const extPermitidas = ["png", "jpg", "jpeg"];

      if (!extPermitidas.includes(extensao)) {
        this.$tools?.alerta?.("Extensão inválida. Use apenas PNG, JPG, JPEG", "error");
        this.limparInputFile();
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        this.$tools?.alerta?.("Arquivo muito grande. Tamanho máximo: 5MB.", "error");
        this.limparInputFile();
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        console.log('Arquivo convertido para base64');
        const base64Completo = e.target.result;
        this.fotoLocal = base64Completo;
        this.$emit("updateFotoPerfil", {
          file: file,
          nomeArquivo: file.name,
          base64Completo: base64Completo,
          base64: base64Completo.split(',')[1],
        });

        this.salvaFotoclienteRural();

        this.limparInputFile();
      };

      reader.onerror = (error) => {
        console.error('Erro ao ler arquivo:', error);
        this.$tools?.alerta?.("Erro ao ler a imagem. Tente novamente.", "error");
        this.limparInputFile();
      };

      reader.readAsDataURL(file);
    },

    limparInputFile() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },

    buscaDadosSotre() {
      const dados = this.$store.state.clienteRuralAstec;
      this.cdCooperadoLocal = dados?.CDCOOPERADO ?? null;
      this.sqClienteLocal = dados?.SQCLIENTE ?? null;

      console.log("FotoClienteRural - cdCooperado:", this.cdCooperadoLocal);
      console.log("FotoClienteRural - sqCliente:", this.sqClienteLocal);
    },

    async enviaFotoApi() {
      try {
        if (!this.sqClienteLocal || !this.fotoLocal) {
          console.warn("Dados insuficientes para salvar a foto.");
          return;
        }

        const formData = new FormData();

        const blob = this.base64ToBlob(this.fotoLocal);
        const nomeArquivo = `cliente_${this.sqClienteLocal}.jpg`;

        formData.append("nm_caminho_foto", blob, nomeArquivo);
        formData.append("sq_cliente", this.sqClienteLocal);
        formData.append("cd_cooperado", this.cdCooperadoLocal);

        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 30000,
        };

        const response = await this.$http.post("api/astec/insertFotoClienteRural", formData, config);

        if (response.data?.success || response.status === 200) {
          this.$tools.alerta("Foto salva com sucesso!", "success");
        } else {
          this.$tools.alerta("Falha ao salvar a foto. Tente novamente.", "error");
        }

      } catch (error) {
        console.error("Erro ao salvar foto:", error);
        const mensagem = error.response?.data?.message || "Erro desconhecido ao salvar a foto.";
        this.$tools.alerta(mensagem, "error");
      }
    },
    base64ToBlob(base64) {
      try {
        const parts = base64.split(';base64,');
        if (parts.length !== 2) {
          console.error('Base64 malformado:', base64);
          return null;
        }
        const contentType = parts[0].split(':')[1];
        const raw = atob(parts[1]);
        const uInt8Array = new Uint8Array(raw.length);

        for (let i = 0; i < raw.length; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }

        console.log('Blob criado com type:', contentType, 'e size:', uInt8Array.length);

        return new Blob([uInt8Array], { type: contentType });
      } catch (err) {
        console.error('Erro ao converter base64 para Blob:', err);
        return null;
      }
},

    salvaFotoclienteRural() {
      if (!this.modoEdicaoFoto || !this.sqClienteLocal) return;
      this.enviaFotoApi();
    },
  }
};
</script>

<style lang="css" scoped>
input[type="file"] {
  display: none;
}

.spinner-overlay {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  width: 80%;
  height: 80%;
  z-index: 10;
}

.avatar-xl {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 3px solid #fff;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  transition: opacity 0.3s ease;
}

.avatar-xl:hover {
  opacity: 0.9;
}

.avatar-sm {
  width: 36px;
  height: 36px;
}

.edit-img {
  z-index: 20;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  transition: all 0.3s ease;
}

.avatar-title:hover {
  transform: scale(1.1);
  background-color: #0056b3 !important;
}
</style>
